<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/club/about" class="active">About Us </a></li>
                            <li><a routerLink="/club/premier-outdoor-venue" >Uptonsteel County Ground</a></li>
                            <!-- <li><a routerLink="/recruitment">Recruitment</a></li> -->
                            <li><a routerLink="/contact" >Contact Us</a></li>                                                          
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="the-running-foxes-section">
            <div class="the-running-foxes-detail">
                <div class="container">
                    <div class="the-running-foxes-tab">
                        <ul>
                            <li class="courses-name active" id="about-the-running"><a routerLink="/club/about">About The Club</a></li>
                            <!-- <li class="courses-name " id="foxes-family"><a href="#">Foxes Family</a></li> -->
                            <li class="courses-name " id="history"><a routerLink="/club/history">Our History</a></li>
                            <li class="courses-name " id="meet-the-board"><a routerLink="/club/meet-the-board">Meet the Board</a></li>
                            <!-- <li class="courses-name " id="ground-development"><a href="#">Ground Development</a></li> -->
                            <li class="courses-name " id="friend-grace-road"><a routerLink="/club/friends-of-grace-road">Friends of Grace Road</a></li>
                            <li class="courses-name " id="leicestershire-cricket-society"><a routerLink="/club/leicestershire-cricket-society">Leicestershire Cricket Society</a></li>
                            <li class="courses-name " id="governance"><a routerLink="/club/governance">Governance</a></li>
                            <li class="courses-name " id="honours"><a routerLink="/club/honours">Honours</a></li>
                            <!-- <li class="courses-name " id="records"><a href="#">Records</a></li> -->
                            <li class="courses-name " id="museum"><a routerLink="/club/museum">Museum</a></li>
                            <li class="courses-name " id="safeguarding"><a routerLink="/club/safeguarding">Safeguarding</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="the-running-foxes-tab-detail">
                <div class="the-running-foxes-section course-main-content active" id="about-the-running-content">
                    <div class="container">
                       
                            <div class="the-running-foxes-top-section cf" *ngIf="aboutfoxList">
                                <div class="the-running-foxes-titel">
                                    <div class="titel-box">
                                        <h2 class="titel-name">{{aboutfoxList?.title}}</h2>
                                    </div>
                                    <p>{{aboutfoxList?.subtitle}}</p>
                                </div>
                                <div class="the-running-foxes-over-values">
                                    <div class="the-running-over-values-box" *ngFor="let box of aboutfoxList?.club_about_running_fox_detail">
                                        <h3>{{box?.title}}</h3>
                                        <div [innerHTML]="box?.description"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="the-running-foxes-center-section" *ngIf="aboutfoxkeyList">
                                <div class="the-running-foxes-titel">
                                    <div class="titel-box">
                                        <h2 class="titel-name">{{aboutfoxkeyList?.title}} </h2>
                                    </div>
                                    <p>{{aboutfoxkeyList?.subtitle}}</p>
                                </div>
                                <div class="the-running-foxes-center-detail-section cf">
                                    <div class="the-running-foxes-center-box" *ngFor="let boxs of aboutfoxkeyList?.club_about_running_fox_detail">
                                        <h3>{{boxs?.title}} </h3>
                                        <div [innerHTML]="boxs?.description"></div>
                                    </div> 
                                </div>
                            </div>
                        
                        <div class="the-running-foxes-bottom-section" *ngIf="runningkeyList?.data?.length > 0">
                            <div class="the-running-foxes-titel">
                                <div class="titel-box">
                                    <h2 class="titel-name">Our Five Key Pillars</h2>
                                </div>
                                <p>Our Values shape the Running Foxes. They are engrained in everyone associated to the club.</p>
                            </div>
                            <div class="the-running-foxes-operate-section cf">
                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideoperateConfig">
                                    <div ngxSlickItem class="the-running-foxes-operate-box slide" *ngFor="let value of runningkeyList?.data">
                                        <div class="the-running-foxes-operate-image">
                                            <img [src]="value?.image">
                                        </div>
                                        <div class="the-running-foxes-operate-titel">
                                            <h3>{{value?.title}}</h3>
                                        </div>
                                        <div class="the-running-foxes-operate-list">
                                            <ul>
                                                <li *ngFor="let key of value?.club_about_running_key_pillar_detail"> {{key?.title}}</li>
                                            </ul>
                                        </div>
                                        <div class="the-running-foxes-operate-subtitle" *ngIf="value?.sub_title != ''">
                                            {{value?.sub_title}}
                                        </div>
                                    </div>
                                </ngx-slick-carousel>
                            </div>
                        </div>
                    </div>
                    <div class="the-running-foxes-bottom-image-section cf" *ngIf="bannerbottomList">
                        <a href="">
                            <img [src]="bannerbottomList?.file">
                        </a>
                    </div>
                </div>
                <div class="club-hero-detail-outer">
                    <div class="container">
                        <div class="club-hero-detail course-main-content " id="governance-content">
                            <div class="club-rules-section"  *ngFor="let governance of governanceList?.data?.club_governance">
                                <div class="titel-box">
                                    <h2 class="titel-name">{{governance?.title}}</h2>
                                </div>
                                <div class="club-rules-content">
                                    <p>{{governance?.subtitle}}</p>
                                </div>
                                <div class="club-rules-btn">
                                    <ul>
                                        <li *ngFor="let clubpdf of governance?.club_governance_pdf"><a href="{{clubpdf?.pdf_url}}" target="_blank" download>{{clubpdf?.title}}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="club-agm-bottom" *ngIf="governanceList?.data?.club_governance_detail?.length > 0">
                                <div class="club-rules-content">
                                    <p>Here is a series of articles with links to the process undertaken for the 2020 AGM:</p>
                                </div> 
                                <div class="club-agm-bottom-btn">
                                    <ul>
                                        <li *ngFor="let detail of governanceList?.data?.club_governance_detail"><p>{{detail?.date}}</p><a href="javascript:void(0)">{{detail?.title}}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="the-running-foxes-history course-main-content" id="history-content">
                                <div class="titel-box">
                                    <h2 class="titel-name">{{historyList?.data?.title}}</h2>
                                </div>
                                <div class="the-running-foxes-history-content" [innerHTML]="historyList?.data?.description">
                                    
                                </div>
                                <div class="titel-box" *ngIf="historyrichprodList?.data?.length > 0">
                                    <h2 class="titel-name">A rich and proud History</h2>
                                </div>
                                <div class="ground-hero-developments" *ngIf="historyrichprodList?.data?.length > 0">
                                    <div class="ground-hero-developments-top" >
                                        <ul>
                                            <li [ngClass]="{ active: i == 0 }" *ngFor="let ground of historyrichprodList?.data; let i = index">
                                                <a href="#">
                                                    <span class="ground-years">{{ground?.title}}</span>
                                                    <div class=" ground-hero-date" *ngFor="let datebydate of ground?.history_rich_proud_detail">
                                                        <div class="ground-date-year">
                                                           
                                                            <span class="ground-date">{{datebydate?.title}}</span>
                                                        </div>
                                                        <div class="ground-date-content">
                                                            <span class="ground-content" *ngIf="ground?.history_rich_proud_detail?.length > 0">
                                                                
                                                                <span>{{datebydate?.description}}</span>
                                                                <img *ngIf="datebydate?.image" [src]="datebydate?.image" class="ground-hero-image">
                                                            </span>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                        </div>
                        <div class="the-running-foxes-meet-board course-main-content" id="meet-the-board-content">
                            <div class="player-staff-box" *ngFor="let board of meetboardList?.data">
                                <a href="#login-box-{{board.club_meet_board_id}}" class="popup-login">
                                    <img [src]="board?.image">
                                    <div class="player-staff-box-overlay">
                                        <p>{{board?.name}}</p>
                                        <h4>{{board?.designation}}</h4>
                                    </div>
                                </a>
                                <div class="login-section-for-login-section matchday mfp-hide  " id="login-box-{{board.club_meet_board_id}}">
                                    <div class="player-staff-box-overlay">
                                        <p>{{board?.name}}</p>
                                        <h4>{{board?.designation}}</h4>
                                        <div [innerHTML]="board?.description"></div>
                                    </div>
						        </div>
                            </div>                            
                        </div>
                        <div class="honours-hero-detail course-main-content" id="honours-content">
                            <div class="titel-box">
                                <h2 class="titel-name">Honours</h2>
                            </div>
                            <div class="honours-hero-first-detail">
                                <div class="honours-hero-first-box" *ngFor="let honour of honoursList?.data">
                                    <h2>{{honour?.title}}</h2>
                                    <div class="honours-hero-first-box-detail">                                       
                                        <div class="honours-hero-box" *ngFor="let detail of honour?.history_honours_detail">
                                            <div class="honours-hero-titel">
                                                <h3>{{detail?.title}}</h3>
                                            </div>
                                            <div class="honours-hero-content">
                                                <p *ngIf="detail?.winners">WINNERS:<span>{{detail?.winners}}</span></p>
                                                <p *ngIf="detail?.runners_up">RUNNERS-UP:<span>{{detail?.runners_up}}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                        <div class="museum-detail-section course-main-content cf" id="museum-content">
                            <div class="museum-detail">
                                <div class="museum-hero-section cf">
                                    <div  class="museum-hero-right">
                                        <img  [src]="museumList?.data?.image">
                                    <div  class="titel-box">
                                        <h2  class="titel-name">{{museumList?.data?.title}}</h2>
                                    </div>
                                    <div class="museum-hero-content" [innerHTML]="museumList?.data?.description">
                                    </div>
                                    
                                    </div>
                                </div>
                            </div>
                            <div class="museum-content-section" [innerHTML]="museumList?.data?.members_description">
                                
                            </div>
                        </div>
                        <div class="club-hero-detail friend-grace-road-section course-main-content" id="friend-grace-road-content">
                            <div class="museum-detail">
                                <div class="museum-hero-section cf">
                                    <div  class="museum-hero-right" >
                                        <img  [src]="clubfriendsList?.image">
                                        <div  class="titel-box" *ngIf="clubfriendsList?.title">
                                            <h2  class="titel-name">{{clubfriendsList?.title}}</h2>
                                        </div>
                                        <div class="museum-hero-content" *ngIf="clubfriendsList?.description">
                                            <div [innerHTML]="clubfriendsList?.description"></div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="museum-sub-committe-section cf" *ngIf="clubcommitteeList?.data?.length > 0">
                                <div class="titel-box">
                                    <h2 class="titel-name">Committee</h2>
                                </div>
                                <div class="sub-committe-detail friend-grace-road cf">                                   
                                    <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidefrienddraceConfig">
                                        <div ngxSlickItem class="player-staff-box slide" *ngFor="let clubcommittee of clubcommitteeList?.data">
                                            <a href="{{clubcommittee?.slug}}">
                                                <img [src]="clubcommittee?.image">
                                                <div class="player-staff-box-overlay ">
                                                    <p>({{clubcommittee?.designation}})</p>
                                                    <h4>{{clubcommittee?.name}}</h4>
                                                </div>
                                            
                                            </a>
                                        </div>
                                        
                                    </ngx-slick-carousel>
                                </div>
                            </div>
                            <div class="museum-content-section" *ngIf="clubfriendsList?.overview" [innerHTML]="clubfriendsList?.overview">
                                
                            </div>
                        </div>
                        <div class="club-hero-detail friend-grace-road-section course-main-content " id="leicestershire-cricket-society-content">
                            <div class="museum-detail">
                                <div class="museum-hero-section cf">
                                    <div  class="museum-hero-right" >
                                        <div  class="titel-box" *ngIf="leicestershireList?.title">
                                            <h2  class="titel-name">{{soccontentList?.title}}</h2>
                                        </div>
                                        <div class="museum-hero-content" *ngIf="leicestershireList?.description">
                                            <div [innerHTML]="soccontentList?.description"></div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="club-hero-detail friend-grace-road-section course-main-content " id="safeguarding-content">
                            <div class="museum-detail" *ngFor="let safe of safeguardingList?.data">
                                <div class="museum-hero-section cf">
                                    <div  class="museum-hero-right" >
                                        <img  [src]="safe?.image" *ngIf="safe?.image">
                                        <div  class="titel-box" *ngIf="safe?.title">
                                            <h2  class="titel-name">{{safe?.title}}</h2>
                                        </div>
                                        <div class="museum-hero-content" *ngIf="safe?.description">
                                            <div [innerHTML]="safe?.description"></div>                                        
                                        </div>
                                        <div class="club-rules-btn" *ngIf="safe?.url">
                                            <ul>
                                                <li><a href="{{safe?.url}}" target="_blank" download>{{safe?.button_title}}</a></li>
                                            </ul>
                                        </div>
                                        
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
   
</section><!-- page ends-->